import { FROM_PREFIX, PARENTHESIS_FORMAT_STRING, TO_PREFIX } from '../constants';
import { format } from 'owa-localize';

export function createFormattedStringWithPrefix(rawString: string, fromFolder: boolean) {
    return format(
        fromFolder ? FROM_PREFIX : TO_PREFIX,
        format(PARENTHESIS_FORMAT_STRING, rawString)
    );
}
